import { useEffect, useState } from "react";
import { IUploaderProps } from "./Uploader.props";
import { UploadFile } from "antd/lib/upload/interface";
import { UploadProps } from "antd/es/upload";
import useApiRequests from "@services/http/useApiRequest";
import {
  DeleteMinerPhotos,
  UploadMinerPhotos,
  UploadPhotoResponse,
} from "@services/uploadMinerPhotos";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { MODALS_ENUM } from "@constants/Modals";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

interface IUploaderControl {
  readonly previewOpen: boolean;
  readonly preview: UploadFile | null;
  readonly canUpload: boolean;
  readonly fileList: UploadFile[];

  onClosePreview(): void;
  onOpenPreview(str: UploadFile): void;
  onUpload: UploadProps["customRequest"];
  onDelete(file: UploadFile): void;
}

export const useUploaderControl = (props: IUploaderProps): IUploaderControl => {
  const { enqueue } = useApiRequests();
  const { onLoader } = useGlobalNotifs();
  const dispatch = useDispatch();
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [preview, setPreview] = useState<UploadFile | null>(null);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const onOpenPreview = (str: UploadFile) => {
    setPreviewOpen(true);
    setPreview(str);
  };

  const onClosePreview = () => {
    setPreviewOpen(false);
    setPreview(null);
  };
  const onUpload: UploadProps["customRequest"] = async (data) => {
    try {
      const res = await enqueue<UploadPhotoResponse>(
        new UploadMinerPhotos({ minerid: props.id, photo: data.file })
      );
      if (!res) return data.onError && data.onError(new Error());
      data.onSuccess && data.onSuccess("ok");
      const file = data.file as UploadFile;
      const changedFile: UploadFile = {
        ...file,
        name: `#${fileList.length + 1}`,
        url: res.Link,
      };
      const changedList = [...fileList, changedFile];
      setFileList(changedList);
    } catch (e) {
      data.onError && data.onError(e as Error);
    }
  };

  const onDelete = (file: UploadFile) => {
    dispatch(
      show(MODALS_ENUM.CONFIRM_MODAL, {
        async onConfirm() {
          const res = await enqueue(
            new DeleteMinerPhotos({ minerid: props.id, photo: file.url || "" }),
            { onLoadingStatusChanged: onLoader }
          );
          if (!res) return;
          setFileList(fileList.filter((f) => f.url !== file.url));
        },
      })
    );
  };

  useEffect(() => {
    const list: UploadFile[] = props.photos.map((p, i) => ({
      uid: `${i + 1}`,
      url: p,
      status: "done",
      name: `#${i + 1}`,
    }));
    setFileList(list);
  }, [props.photos]);

  useEffect(() => {
    const list = fileList.map((f) => f.url || "");
    props.onSavePhotos(list);
  }, [fileList]);

  return {
    previewOpen,
    preview,
    canUpload: fileList.length < 5,
    fileList,

    onOpenPreview,
    onClosePreview,
    // onSetFileList,
    onUpload,
    onDelete,
  };
};
